import { api } from "@/lib/api"
import { StatusPill } from "./site-import-banner"

const POLL_MS = 3000

export interface ProductMapStatus {
	state: "running" | "done" | "failed"
	repositoryFullName: string
	total: number | null
	finished: number
	written: number
}

export function productMapBannerText(status: ProductMapStatus) {
	const repo = status.repositoryFullName

	if (status.state === "running") {
		return status.total
			? `Mapping your product from ${repo}: ${status.finished} of ${status.total} screens.`
			: `Mapping your product from ${repo}.`
	}

	if (status.state === "failed") return `Couldn't map ${repo}.`

	if (status.written === 0) {
		return `Mapped ${repo}. Every article was already current.`
	}
	return `Mapped ${status.written} screen${status.written === 1 ? "" : "s"} from ${repo}.`
}

export function ProductMapBanner() {
	const context = api.useUtils()
	const { data: status } = api.repoIntegration.getRemapProgress.useQuery(
		undefined,
		{
			refetchInterval: (data) => (data?.state === "running" ? POLL_MS : false),
			refetchOnWindowFocus: true,
		},
	)
	const dismiss = api.repoIntegration.dismissRemapProgress.useMutation({
		onSuccess: async () => {
			await context.repoIntegration.getRemapProgress.invalidate()
		},
	})

	if (!status) return null

	return (
		<StatusPill
			state={status.state}
			text={productMapBannerText(status)}
			openTo="/edit-docs"
			dismissLabel="Dismiss product map status"
			onDismiss={() => dismiss.mutate()}
		/>
	)
}
